import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../utils/api';
import { useRealtime } from '../utils/realtime';

/* Accès de la personne connectée (GET /acces/moi) : rôle · modules · lecture seule. Partagé entre barre de gauche, menu mobile et redirection par rôle ; se rafraîchit sur l'événement temps réel `acces.updated`. */
let _cache = null;
let _promise = null;
const _subs = new Set();
const TOUT = { role: 'direction', role_label: 'Direction', modules: null, lecture_seule: false, ouvre_sur: 'accueil', loaded: false };

export const chargerAcces = (force = false) => {
  if (_cache && !force) return Promise.resolve(_cache);
  if (_promise && !force) return _promise;
  _promise = axios.get(`${getApiUrl()}/acces/moi`, { withCredentials: true })
    .then((r) => { _cache = { ...r.data, loaded: true }; _subs.forEach((f) => f(_cache)); return _cache; })
    .catch(() => { _cache = { ...TOUT, loaded: true }; _subs.forEach((f) => f(_cache)); return _cache; })
    .finally(() => { _promise = null; });
  return _promise;
};
export const resetAcces = () => { _cache = null; };

export const useAcces = () => {
  const [a, setA] = useState(_cache || TOUT);
  useEffect(() => { _subs.add(setA); chargerAcces(); return () => _subs.delete(setA); }, []);
  useRealtime(['acces.updated', 'config.applied'], () => chargerAcces(true));
  return a;
};

/** Un module (clé de MODULES_360) est-il visible pour cet accès ? `null` = tout. */
export const moduleVisible = (acces, key) => !acces?.modules || acces.modules.includes(key);
